import { create } from "zustand";

export interface FilterState {
  queryString: string;
  productId: string;
  productName: string;
  productType: string[];
  status: string[];
}

type State = FilterState;

type Actions = {
  actions: {
    setState: (state: FilterState) => void;
    setQueryString: (queryString: string) => void;
  };
};

const filterStore = create<State & Actions>(set => ({
  // State
  productId: "",
  productName: "",
  productType: [],
  status: [],
  queryString: "",

  // Actions
  actions: {
    setState: newState =>
      set(() => ({
        ...newState,
      })),
    setQueryString: queryString =>
      set(() => ({
        queryString: queryString,
      })),
  },
}));

export const useFilterStore = () => {
  return filterStore(store => ({
    productId: store.productId,
    productName: store.productName,
    productType: store.productType,
    status: store.status,
  }));
};

export const useSetFilterStore = () => {
  return filterStore(store => store.actions.setState);
};

export const useFilterQuery = () =>
  filterStore(store => ({
    queryString: store.queryString,
    setQueryString: store.actions.setQueryString,
  }));
